// Google Map
(function initFormIframe (options, markers) {

	// Validation Client side and Captcha call.
	function validate(event) {
		console.log('after validate, call captcha');
		grecaptcha.execute();
	}

	function onloadFormFooter() {
		var element = document.getElementById('zY21zX2ZpZWxkXzY');
			element.onclick = validate;
	}

	// Validation : definition des messages.
	 jQuery.extend(jQuery.validator.messages, {
	    required: "Ce champ est requis.",
	    email: "Veuillez sairir une adresse e-mail valide.",
	 });


	// Formulaire contact bien.
	$('#cms_forms_13').validate({
		submitHandler: validate,
		rules: {
			"57caf42c35a5d9c2721ae0f5362839c9":{ //Nom.
				"required": true,
			},
			"1863179f4fa3ed2ad6bb6bba5c827e0c": { // Email.
				"required": true,
				"email": true,
			}
		}
	});
}())